import React, { useMemo } from 'react';
import { Indicator, Text, Box } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { IconProps } from '@tabler/icons-react';

export type ModuleLink = {
    label: string;
    path: string;
    showIndicator?: boolean;
    icon: (props: IconProps) => React.ReactNode;
};

type Props = {
    pathPrefix?: string;
    link: ModuleLink;
    onClick?: () => void;
};

function SidebarItem({ link, pathPrefix, onClick }: Props) {
    const { label, path, showIndicator } = link;
    const { pathname } = useLocation();

    const active = useMemo(() => {
        const pathnameSplit = `${pathname ?? ''}/`.split('/').slice(2);
        const pathSplit = path?.split('/');
        return pathnameSplit[0] === pathSplit[0];
    }, [pathname, path]);

    const linkOnClick = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <Link
            to={`${pathPrefix}${path}`}
            onClick={linkOnClick}
            style={{ textDecoration: 'none' }}
        >
            <Box
                w={78}
                h={78}
                p={0}
                className={`flex flex-col items-center justify-center cursor-pointer transition
          ${
              active
                  ? 'bg-primary-light text-primary font-semibold'
                  : 'text-stone-500 hover:bg-slate-100 hover:text-primary hover:font-semibold'
          }
        `}
            >
                <Indicator
                    color="red"
                    processing
                    inline
                    disabled={!showIndicator}
                    size={10}
                >
                    <link.icon className="text-primary" />
                </Indicator>
                <Text size="xs" className="p-px no-underline text-center">
                    {label}
                </Text>
            </Box>
        </Link>
    );
}

export default SidebarItem;
